import { type ReactNode } from "react";
import { type LucideIcon } from "lucide-react";

type InfoContentSectionProps = {
  children: ReactNode;
  icon: LucideIcon;
  title: string;
};

const InfoContentSection = ({
  children,
  icon: Icon,
  title,
}: InfoContentSectionProps) => {
  return (
    <div
      style={{ backgroundColor: "#f8f9fa" }}
      className="d-flex gap-3 p-3 border rounded-3"
    >
      <Icon
        className="flex-shrink-0 text-primary mt-1"
        size={22}
        aria-hidden
        strokeWidth={1.8}
      />
      <div>
        <h3 className="fs-6 fw-semibold mb-1">{title}</h3>
        <p className="mb-0 text-muted">{children}</p>
      </div>
    </div>
  );
};

export default InfoContentSection;
